module.exports = __webpack_public_path__ + "static/images/dialog-img-icons.5628373.png";